import { Injectable } from '@angular/core';
import { HttpMethod } from '@datorama/akita-ng-entity-service';
import { environment } from 'src/environments/environment';
import { CustomHeader, CustomRequest } from 'src/app/core/models/CustomRequest';
import { HttpHeaderType } from 'src/app/core/enums/HttpHeaderType';
import { StoreMode } from 'src/app/core/enums';
import { CustomService } from 'src/app/core/services/custom.service';
import { UserStore } from 'src/app/core/user/user.store';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { UserQuery } from 'src/app/core/user/user.query';
import { User, mapLoginResp } from 'src/app/core/user/user.model';
import { BehaviorSubject } from 'rxjs';
import { UserService } from 'src/app/core/user/user.service';
import { MessengerLinkRequest } from 'src/app/core/models/MessengerLinkRequest';
import { AuthService } from 'src/app/core/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class MessengerService {

  accessToken: string = "";
  refreshToken: string = "";
  curUser: User | null = null;

  showSuccessLogin = new BehaviorSubject<{ isSuccess?: boolean; }>(null);
  showFailLogin = new BehaviorSubject<{ isFail?: boolean; }>(null);

  get(storeMode: StoreMode) {
    let entities = null;
    if (storeMode === StoreMode.External) {
      this.userStore.setLoading(true);
      entities = this.http.get('https://akita.com');
      this.userStore.setLoading(false);
    }
    return this.userQuery.selectFirst();
  }

  constructor(
    private userStore: UserStore,
    private http: HttpClient,
    private customService: CustomService,
    private userQuery: UserQuery,
    private userService: UserService,
    private authService: AuthService,
  ) {
    this.get(StoreMode.Internal).subscribe(async (userData: any) => {
      this.accessToken = userData && userData['accessToken'] ? userData['accessToken'] : '';
      this.refreshToken = userData && userData['refreshToken'] ? userData['refreshToken'] : '';
      this.curUser = userData;
    });
  }

  async generateMessenger(generateMessageRequestModel: MessengerLinkRequest) {
    let respDt = null;
    respDt = await this.reqGenerateMessage(generateMessageRequestModel, this.accessToken);

    if (!(respDt instanceof HttpErrorResponse)) {
      respDt = respDt;

      return respDt;
    }
    else {
      this.showFailLogin.next({
        isFail: true,
      });

      return respDt;
    }
  }

  async getmessagestatus(messageKey: string): Promise<any> {
    let respDt = null;

    respDt = await this.reqGetmessagestatus(messageKey);
    if (respDt instanceof (HttpErrorResponse)) {
      this.showFailLogin.next({
        isFail: true,
      });

      return respDt;
    }

    if (respDt.messageResponse === null) {
      return respDt;
    }

    const rawMessage = respDt?.messageResponse;
    const result = JSON.parse(rawMessage);
    result.claims = result.claims?.map((c: any) => ({
      type: c.Type,
      value: c.Value
    }));

    this.accessToken = result?.access_token;

    await this.userService.updateToken(result);
    let convertedTokenResponse = mapLoginResp(result);

    let isSuccess = await this.authService.finalizeLoginState(convertedTokenResponse, undefined, false, true, true);

    if (isSuccess === true) {
      this.showSuccessLogin.next({
        isSuccess: true
      });
      return true;
    } else {
      this.showFailLogin.next({
        isFail: true,
      });
      return isSuccess;
    }
  }

  getWhatsappLoginStatus() {
    return this.showSuccessLogin.asObservable();
  }

  getWhatsappStatus() {
    return this.showFailLogin.asObservable();
  }

  async reqGenerateMessage(messengerLinkRequest: MessengerLinkRequest, accessToken: string) {

    const body: any = {
      templateCode: messengerLinkRequest.templateCode,
      sender: messengerLinkRequest.sender,
      msgParamsData: messengerLinkRequest.msgParamsData
    };

    const newCr = {
      httpMethod: HttpMethod.POST,
      requestpath: environment.apis.messenger.GenerateMessageLink,
      hostPath: environment.hostPath,
      headers: {
        accessToken: accessToken,
      } as CustomHeader,
      body: body,
      httpHeaderType: HttpHeaderType.Auth
    } as CustomRequest;

    this.userStore.setLoading(true);
    const respInfo = await this.reqCustomHttpCall(newCr);
    this.userStore.setLoading(false);
    return respInfo;
  }

  async reqGetmessagestatus(messageKey: string) {
    let newCr = {
      httpMethod: HttpMethod.GET,
      requestpath: environment.apis.messenger.GetMessageStatus,
      hostPath: environment.hostPath,
      headers: {
        accessToken: this.accessToken,
      } as CustomHeader,
      queryParams: {
        messageKey: messageKey ?? undefined,
      },
      httpHeaderType: HttpHeaderType.Auth
    } as CustomRequest;

    let respInfo = null;
    this.userStore.setLoading(true);
    respInfo = await this.reqCustomHttpCall(newCr);
    this.userStore.setLoading(false);
    return respInfo;
  }

  private reqCustomHttpCall(cusreq: CustomRequest) {
    const cSv = this.customService;
    return cSv.createRequest(cusreq).then((dd: any) => dd['body'] || dd['body'] === '' ? dd['body'] : dd);
  }
}
